import { AuthFlow } from './AuthFlow';
import styled from 'styled-components';
import { black, lighterBlueBackground, white } from '../components/colors';
import { TermsDrawer } from '../TermsDrawer';
import { PrivacyDrawer } from '../PrivacyDrawer';
import React, { useEffect, useState } from 'react';
import { useStore } from '@nanostores/react';
import { $isTermsIsOpen } from '../store/modals';
import { logoIcon as WpLogoIcon, logoName as WpLogoName, appLogoIconAlt, appLogoNameAlt } from '../sportConfig';
import { AuthContainer, Container, LogoContainer, LogoText } from '../ui/common';
import { $auth } from '../store/auth';
import { useNavigate } from 'react-router-dom';

export const AuthPage = () => {
  const [isTermsOpen, setTermsIsOpen] = useState(false)
  const [isPrivacyOpen, setPrivacyIsOpen] = useState(false)
  const _isTermsIsOpen = useStore($isTermsIsOpen)
  const _isPrivacyOpen = useStore($isTermsIsOpen)
  const [init, setInit] = useState(true)
  const authStore = useStore($auth)
  const navigate = useNavigate()

  useEffect(() => {
    if (init) {
      setInit(false)
      if (authStore.isLoggedIn) {
        navigate('/')
      }
    }
  }, []);

  useEffect(() => {
    setPrivacyIsOpen(_isPrivacyOpen)
  }, [_isPrivacyOpen]);

  useEffect(() => {
    setTermsIsOpen(_isTermsIsOpen)
  }, [_isTermsIsOpen]);

  return (
    <AuthContainer>
      <Container>
        <LogoContainer>
          <img
            src={WpLogoIcon}
            alt={appLogoIconAlt}
          />
          <LogoText
            src={WpLogoName}
            alt={appLogoNameAlt}
            width={640}
            height={260}
          />
        </LogoContainer>
        <AuthFlow />
      </Container>
      <TermsDrawer
        isOpen={isTermsOpen}
        onClose={() => $isTermsIsOpen.set(false)}
      />
      <PrivacyDrawer
        isOpen={isPrivacyOpen}
        onClose={() => $isTermsIsOpen.set(false)}
      />
    </AuthContainer>
  )
}